var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-tooltip',{attrs:{"bottom":"","color":"black"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"material-icons ml-2",attrs:{"color":"#aaaaaa","size":"20"}},on),[_vm._v("chat_bubble")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.justificativa))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }